import { t } from 'i18next';

export type InactiveSireError = {
  code: string;
  sireId: string;
  sireName?: string | null;
  registrationNumber?: string | null;
};

const INACTIVE_SIRE_ERROR_KEYS: Record<string, string> = {
  INACTIVE_SIRE_CHOOSE_ACTIVE_FOR_SEMEN:
    'sire.inactiveSireErrors.chooseActiveForSemen',
  INACTIVE_SIRE_FIX_MATING_BEFORE_EMBRYOS:
    'sire.inactiveSireErrors.fixMatingBeforeEmbryos',
  INACTIVE_SIRE_FIX_SEMEN_OR_MATING: 'sire.inactiveSireErrors.fixSemenOrMating',
  INACTIVE_SIRE_FIX_SEMEN_BEFORE_MATING:
    'sire.inactiveSireErrors.fixSemenBeforeMating',
};

function isInactiveSireError(value: unknown): value is InactiveSireError {
  return (
    typeof value === 'object' &&
    value !== null &&
    'code' in value &&
    'sireId' in value
  );
}

export function parseInactiveSireErrors(
  body: string,
): InactiveSireError[] | null {
  try {
    const parsed: unknown = JSON.parse(body);
    return Array.isArray(parsed) && parsed.every(isInactiveSireError)
      ? parsed
      : null;
  } catch {
    return null;
  }
}

export function translateInactiveSireError(error: InactiveSireError): string {
  const name = error.registrationNumber
    ? `${error.sireName} (${error.registrationNumber})`
    : error.sireName;
  return t(
    INACTIVE_SIRE_ERROR_KEYS[error.code] ??
      'sire.inactiveSireErrors.fixSemenOrMating',
    { name },
  );
}

export function translateInactiveSireErrors(body: string): string | null {
  const errors = parseInactiveSireErrors(body);
  return errors ? errors.map(translateInactiveSireError).join(' ') : null;
}

type SireWithState = { stateCode?: number | null } | null | undefined;

export const isSireInactive = (sire: SireWithState): boolean =>
  sire?.stateCode != null && sire.stateCode !== 0;
